import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "../components/login/Login";
import { selectUser } from "../redux/slices/userSlice";
import RunScenariosScreen from "../components/Configure/RunScenariosScreen";
import ReportsScreen from "../components/Reports/ReportsScreen";

const Routers = () => {
  const user = useSelector(selectUser);

  return (
    <Routes>
      {user ? (
        <>
          {["/", "/login"].map((path, index) => (
            <Route
              path={path}
              key={index}
              element={<Navigate to="/configure" />}
            />
          ))}
          {/* <Route
            path="/*"
            element={<Navigate to="/configure" />}
          /> */}
          <Route
            path="/configure"
            element={<RunScenariosScreen />}
          />
          <Route
            path="/reports"
            element={<ReportsScreen />}
          />
        </>
      ) : (
        <>
          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/*"
            index
            element={<Navigate to="/login" />}
          />
        </>
      )}
    </Routes>
  );
};

export default Routers;
